import { MidiKey } from "../../midi/MidiKey";
import { AudioBuilderContext } from "../AudioBuilderContext";
import { SineComponent } from "../components/SineComponent";
import { Instrument } from "../Instrument";
import { Key } from "../Key";
import { ElementType } from "../../../dom-tools/ElementType";
import { Vector2 } from "three";
import { OnClick } from "../../../dom-tools/EventListeners";
import * as Tone from "tone";
import { FloatArrayAudioData } from "../../data/FloatArrayAudioData";

export class AudioBuilderTest
{
  static type = new ElementType( "audio-builder-test" );

  static applyOnDocument()
  {
    let el = AudioBuilderTest.type.queryDoc();

    if ( ! el )
    {
      return;
    }

    new AudioBuilderTest().test( el );
  }

  async test( element:Element )
  {
    let midiKey = MidiKey.C1;

    console.log( "testing audio builder:" );

    let instrument = new Instrument();
    instrument.velocity.curve.set(
       [ 
        new Vector2( 0, 0 ),
        new Vector2( 0.01, 1 ),
        new Vector2( 0.99, 1 ),
        new Vector2( 1, 0 ),
      ] 
    );
    
    let key = new Key();
    key.midiKey = midiKey;
    instrument.keys.push( key );

    let numHarmonics = 10;

    for ( let i = 0; i < numHarmonics; i++ )
    {
      let sine = new SineComponent();
      sine.harmonicIndex = i * 2 + 1;
      sine.velocityMultiply = 1 / ( sine.harmonicIndex ); 

      instrument.components.push( sine );
    }

    

    let context = AudioBuilderContext.create( 44100, 1 );
    
    let ad = await instrument.generateKey( key, context );
    
    console.log( "created", ad );

    

    let samplerInstrument:Tone.Sampler = null;

    let keys:MidiKey[] = MidiKey.createRange( MidiKey.C1, MidiKey.C2 );
    

    for ( let i = 0; i < keys.length; i++ )
    {
      let button = ElementType.button.create( keys[ i ].info );
      element.appendChild( button );

      let playingKey = keys[ i ];

      OnClick.add( button, 
        ()=>
        {
          if ( ! samplerInstrument )
          {
            let samples = 
            {
              [ midiKey.pitch ] : FloatArrayAudioData.cast( ad ).toToneAudioBuffer()
            };

            samplerInstrument = new Tone.Sampler( samples ).toDestination();
          }         
          
          samplerInstrument.triggerAttackRelease( playingKey.info, "16n" );        
        }
      );
    }

    
  }
}